import { render, staticRenderFns } from "./BuyerInvoice.vue?vue&type=template&id=4628c4be&"
import script from "./BuyerInvoice.vue?vue&type=script&lang=js&"
export * from "./BuyerInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports